// These are rule ids used for things like creating new configs or templates
export default ['New', 'bulkEdit', 'createTemplate']